import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface INagar_Khanda {
nagar_khanda_id:number,
nagar_khanda_name:string,
zilla_id:number,
seq_no:number,
is_active:number
}

interface INagar_KhandaData {
    list?: Array<INagar_Khanda>;
    pageNo: number;
    pageSize: number;
    searchKey?: string;
    totalCount?: number;
    message?: string;
}

const initialState: INagar_KhandaData = {
    pageNo: 1,
    pageSize: 20,
    searchKey: '',
    list: [],
    totalCount: 0,
    message: '',
};

const nagar_khandaSlice = createSlice({
    name: "nagar_khanda",
    initialState,
    reducers: {
        setNagar_KhandaList: (state, _action: PayloadAction<INagar_KhandaData>) => {
            state.list = _action.payload.list;
            state.pageNo = _action.payload.pageNo;
            state.pageSize = _action.payload.pageSize;
            state.totalCount = _action.payload.totalCount;
        },
        resetNagar_KhandaToInit: (state) => {
            state = initialState;
        },
        setNagar_KhandaMessage: (state, _action: PayloadAction<string>) => {
            state.message = _action.payload;
        },
    },
});

export const { setNagar_KhandaList, resetNagar_KhandaToInit, setNagar_KhandaMessage } = nagar_khandaSlice.actions;

export default nagar_khandaSlice.reducer;

